import PropTypes from 'prop-types';
import React from 'react';

export default function SearchStyles(props) {
  const { settings } = props;
  const {
    darkColor,
    lightColor,
    borderColor,
    backgroundColor,
    textColor,
    buttonColor,
    containerCssSelector = '',
  } = settings;

  const styles = `
    ${containerCssSelector} .snapgadget_main_container{
      color: ${textColor};
      display: flex;
      flex-direction: column;
    }
    ${containerCssSelector} .snapgadget_refine .snapgadget-sort-order{
      border: 1px solid ${darkColor};
      background:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' fill='#FFF' width='50px' height='50px'><polyline points='46.139,15.518 25.166,36.49 4.193,15.519'/></svg>") right no-repeat;
      background-color: ${darkColor};
      color: ${buttonColor};
    }
    ${containerCssSelector} .snapgadget_refine .snapgadget-sort-order:active{
      border: 1px solid ${lightColor};
      background-color: ${lightColor};
    }
    ${containerCssSelector} .snapgadget_refine .snapgadget-sort-order:hover{
      border: 1px solid ${lightColor};
      background-color: ${lightColor};
    }
    ${containerCssSelector} .snapgadget_search_container .snapgadget_query_container .snapgadget_query{
      border: solid 2px ${borderColor};
    }
    ${containerCssSelector} .snapgadget_search_container .snapgadget-btn, .snapgadget-load-more-btn, .snapgadget-clear-filter .snapgadget-btn{
      background-color: ${darkColor};
    }
    ${containerCssSelector} .snapgadget_results .snapgadget_result{
      ${borderColor ? `border: solid 2px ${borderColor}` : ''};
      ${backgroundColor ? `background-color:${backgroundColor}` : ''};
    }
    ${containerCssSelector} .snapgadget_results .snapgadget_result a{
      color: ${textColor};
    }
    ${containerCssSelector} .snapgadget_results .snapgadget_result .snapgadget_header{
      color: ${textColor};
    }
    ${containerCssSelector} .snapgadget_results .snapgadget_result .snapgadget_footer .snapgadget_price{
      color: ${textColor};
    }
  `;
  return <style dangerouslySetInnerHTML={{ __html: styles }} />;
}

SearchStyles.propTypes = {
  settings: PropTypes.shape({
    darkColor: PropTypes.string,
    borderColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    buttonColor: PropTypes.string,
    lightColor: PropTypes.string,
    containerCssSelector: PropTypes.string,
  }).isRequired,
};
